import React from 'react';
import styles from './styles.css';
import classnames from 'classnames';
import Tick from '../icons/tick';

export class Shade extends React.Component {

    constructor(props) {
        super(props);
    };

    render() {

        let shade = this.props.shade;

        return (
            <span className={classnames(styles.shade, shade.active ? styles.active : '')}
                style={{ backgroundColor: shade.hex }}
                onClick={() => { this.props.onClick(); }}
                >
                    {
                        shade.active &&
                        <Tick className={styles.tick}></Tick>
                    }
            </span>
        )
    };
};